var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJcbIcon = function SvgJcbIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 3.3448 0 7.47082 0H48V24C48 27.3137 44.6552 30 40.5292 30H0V6Z",
    fill: "#EEF1F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6163 15.5164C33.5388 15.5364 34.4665 15.4756 35.3853 15.5479C36.3157 15.7215 36.54 17.1301 35.7133 17.5914C35.1493 17.8954 34.4793 17.7046 33.8678 17.7582H32.6163V15.5164ZM35.9187 12.9789C36.1236 13.7023 35.4262 14.3518 34.7295 14.2522H32.6163C32.6312 13.57 32.5874 12.8295 32.6378 12.1832C33.4843 12.2071 34.3387 12.1346 35.1803 12.2211C35.542 12.312 35.8446 12.6093 35.9187 12.9789ZM41.0043 2.25103C41.0436 3.63254 41.01 5.08708 41.0213 6.49661C41.0187 12.2273 41.0268 17.9578 41.0168 23.6888C40.9797 25.8365 39.0763 27.7027 36.9434 27.7456C34.8085 27.7542 32.6733 27.7469 30.5381 27.7493V19.0857C32.8645 19.0737 35.1921 19.1101 37.5176 19.0675C38.5963 18.9998 39.778 18.288 39.8282 17.1008C39.9552 15.9085 38.8311 15.0839 37.7639 14.9536C37.3536 14.943 37.3656 14.834 37.7639 14.7865C38.7818 14.5665 39.5811 13.513 39.2816 12.4579C39.0264 11.3481 37.7998 10.9186 36.7796 10.9208C34.6994 10.9066 32.6189 10.9188 30.5386 10.9147C30.552 9.2973 30.5106 7.67818 30.5609 6.06198C30.7257 3.95304 32.677 2.21385 34.7799 2.25158C36.855 2.25126 38.9297 2.25126 41.0043 2.25118V2.25103Z",
    fill: "url(#paint0_linear_3864_47349)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02994 6.2803C7.08307 4.136 8.99458 2.28511 11.1247 2.25377C13.2517 2.24722 15.379 2.25283 17.506 2.25093C17.5002 9.42532 17.5176 16.6005 17.4973 23.7745C17.4153 25.8928 15.5247 27.7084 13.4178 27.7458C11.2867 27.7536 9.15546 27.747 7.02434 27.7491V18.7934C9.09436 19.2825 11.2651 19.4906 13.3769 19.1663C14.6392 18.9632 16.0203 18.3432 16.4477 17.0336C16.7622 15.9134 16.5851 14.7345 16.6319 13.5847V10.9146H12.9773C12.9609 12.6805 13.0109 14.4496 12.9509 16.2134C12.8523 17.2975 11.7787 17.9864 10.7562 17.9496C9.48811 17.963 6.97524 17.0306 6.97524 17.0306C6.96892 13.7219 7.01202 9.57831 7.02994 6.28062V6.2803Z",
    fill: "url(#paint1_linear_3864_47349)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8695 11.9915C18.6771 12.0323 18.8308 11.3362 18.7816 11.0722C18.7947 9.40261 18.7542 7.73123 18.8039 6.06285C18.9683 3.94499 20.9346 2.20146 23.046 2.25103H29.2638C29.258 9.42542 29.2752 16.6006 29.255 23.7746C29.173 25.8928 27.2822 27.7084 25.1752 27.7459C23.0441 27.754 20.9128 27.7472 18.7815 27.7493V17.9371C20.2371 19.1314 22.2154 19.3173 24.0287 19.3205C25.3958 19.3201 26.7549 19.1093 28.0825 18.794V16.9964C26.5864 17.7421 24.8276 18.2157 23.1691 17.7873C22.0122 17.4993 21.1723 16.3812 21.1911 15.1873C21.057 13.9456 21.7848 12.6348 23.005 12.2657C24.5199 11.7914 26.171 12.1541 27.591 12.7707C27.8952 12.93 28.204 13.1276 28.0824 12.6191V11.2061C25.7075 10.6411 23.18 10.4332 20.794 11.0479C20.1034 11.2427 19.4305 11.5381 18.8695 11.9917V11.9915Z",
    fill: "url(#paint2_linear_3864_47349)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3864_47349",
    x1: 30.4665,
    y1: 14.455,
    x2: 40.9551,
    y2: 14.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3864_47349",
    x1: 6.80132,
    y1: 15.2442,
    x2: 17.3342,
    y2: 15.2442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3864_47349",
    x1: 18.7662,
    y1: 14.702,
    x2: 29.2618,
    y2: 14.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
};
export default SvgJcbIcon;